import { createTheme, MantineColorsTuple } from '@mantine/core';

// Deep purple gradient inspired by the Stakent dashboard
const primaryColor: MantineColorsTuple = [
  '#f8f4ff',
  '#e9dcff',
  '#d0b8ff',
  '#b794ff',
  '#a370ff',
  '#9854ff',
  '#8b42ff',
  '#7c2aff',
  '#6b1bff',
  '#5a0cff'
];

// Rich purple accent colors
const purpleAccent: MantineColorsTuple = [
  '#faf5ff',
  '#f3e8ff',
  '#e9d5ff',
  '#d8b4fe',
  '#c084fc',
  '#a855f7',
  '#9333ea',
  '#7c3aed',
  '#6d28d9',
  '#5b21b6'
];

// Deep dark colors for backgrounds
const darkColors: MantineColorsTuple = [
  '#f8fafc',
  '#f1f5f9',
  '#e2e8f0',
  '#cbd5e1',
  '#94a3b8',
  '#64748b',
  '#475569',
  '#334155',
  '#1e293b',
  '#0f172a'
];

export const theme = createTheme({
  primaryColor: 'purple',
  colors: {
    purple: primaryColor,
    purpleAccent: purpleAccent,
    dark: darkColors,
  },
  fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '600',
  },
  defaultRadius: 'lg',
  cursorType: 'pointer',
  
  // Enhanced dark theme colors
  other: {
    // Deep backgrounds inspired by the Stakent dashboard
    deepBackground: '#0a0a0f',
    cardBackground: '#12121a',
    surfaceBackground: '#1a1a24',
    
    // Purple gradients
    primaryGradient: 'linear-gradient(135deg, #8b42ff 0%, #a855f7 50%, #c084fc 100%)',
    accentGradient: 'linear-gradient(135deg, #5b21b6 0%, #7c3aed 50%, #9333ea 100%)',
    
    // Glass morphism effects
    glassBackground: 'rgba(18, 18, 26, 0.8)',
    glassBorder: 'rgba(139, 66, 255, 0.2)',
    
    // Text colors for dark theme
    textPrimary: '#ffffff',
    textSecondary: '#a1a1aa',
    textMuted: '#71717a',
  },
});